export default __webpack_public_path__ + "static/media/bg_craft.ad17d446.png";